<template>
  <div>
    <div
      v-if="show"
      class="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto p-4"
      ref="modalContainer"
      @keydown="checkKeyEvent"
    >
      <div
        class="modal-max-height flex w-full flex-col rounded-3xl bg-white"
        :class="{
          'max-w-[511px]': size === 'sm',
          'max-w-[688px]': size === 'md',
          'max-w-[880px]': size === 'lg',
        }"
      >
        <!--content-->
        <div
          v-if="showHeader"
          id="header"
          class="border-neutral-20 flex border-b"
          :class="{
            'h-[52px] px-4 py-2': size === 'sm',
            'h-[70px] px-6': size === 'md',
            'h-[76px] px-10': size === 'lg',
          }"
        >
          <slot name="header">
            <div class="flex grow flex-row items-center justify-between">
              <div class="flex items-center gap-2">
                <ImoIcon v-if="headerIcon" :name="headerIcon" :size="20" />
                <h4 class="text-primary-90 font-semibold">
                  {{ title }}
                </h4>
              </div>
              <ImoButton
                v-if="closeable"
                @click="closeModal"
                icon="close"
                variant="tertiary"
                ref="exitButton"
              />
            </div>
          </slot>
        </div>
        <!--body-->
        <div
          id="modal-body"
          class="flex w-full flex-1 flex-col overflow-x-hidden overflow-y-auto py-2"
          :class="{
            'min-h-[150px] px-4': size === 'sm',
            'min-h-[376px] px-6': size === 'md',
            'min-h-[656px] px-10': size === 'lg',
          }"
        >
          <slot name="body">
            <div class="relative flex-auto">
              <p class="text-lg leading-relaxed text-slate-500">
                Mussum Ipsum, cacilds vidis litro abertis. Si num tem leite então bota uma pinga aí
                cumpadi! Praesent malesuada urna nisi, quis volutpat erat hendrerit non. Nam
                vulputate dapibus. Em pé sem cair, deitado sem dormir, sentado sem cochilar e
                Praesent vel viverra nisi. Mauris aliquet nunc non turpis scelerisque, eget.Mussum
                Ipsum, cacilds vidis litro abertis. Si num tem leite então bota uma pinga aí
                cumpadi! Praesent malesuada urna nisi, quis volutpat erat hendrerit non. Nam
                vulputate dapibus. Em pé sem cair, deitado sem dormir, sentado sem cochilar e
                fazendo pose. Praesent vel viverra nisi. Mauris aliquet nunc non turpis scelerisque,
                eget.Mussum Ipsum, cacilds vidis litro abertis. Si num tem leite então bota uma
                pinga aí cumpadi! Praesent malesuada urna nisi, quis volutpat erat hendrerit non.
                Nam vulputate dapibus. Em pé sem cair, deitado sem dormir, sentado sem cochilar e
                fazendo pose. Praesent vel viverra nisi. Mauris aliquet nunc non turpis scelerisque,
                eget.Mussum Ipsum, cacilds vidis litro abertis. Si num tem leite então bota uma
                pinga aí cumpadi! Praesent malesuada urna nisi, quis volutpat erat hendrerit non.
                Nam vulputate dapibus. Em pé sem cair, deitado sem dormir, sentado sem cochilar e
                fazendo pose. Praesent vel viverra nisi. Mauris aliquet nunc non turpis scelerisque,
                eget.Mussum Ipsum, cacilds vidis litro abertis. Si num tem leite então bota uma
                pinga aí cumpadi! Praesent malesuada urna nisi, quis volutpat erat hendrerit non.
                Nam vulputate dapibus. Em pé sem cair, deitado sem dormir, sentado sem cochilar e
                fazendo pose. Praesent vel viverra nisi. Mauris aliquet nunc non turpis scelerisque,
                eget.Mussum Ipsum, cacilds vidis litro abertis. Si num tem leite então bota uma
                pinga aí cumpadi! Praesent malesuada urna nisi, quis volutpat erat hendrerit non.
                Nam vulputate dapibus. Em pé sem cair, deitado sem dormir, sentado sem cochilar e
                fazendo pose. Praesent vel viverra nisi. Mauris aliquet nunc non turpis scelerisque,
                eget.Mussum Ipsum, cacilds vidis litro abertis. Si num tem leite então bota uma
                pinga aí cumpadi! Praesent malesuada urna nisi, quis volutpat erat hendrerit non.
                Nam vulputate dapibus. Em pé sem cair, deitado sem dormir, sentado sem cochilar e
                fazendo pose. Praesent vel viverra nisi. Mauris aliquet nunc non turpis scelerisque,
                eget.Mussum Ipsum, cacilds vidis litro abertis. Si num tem leite então bota uma
                pinga aí cumpadi! Praesent malesuada urna nisi, quis volutpat erat hendrerit non.
                Nam vulputate dapibus. Em pé sem cair, deitado sem dormir, sentado sem cochilar e
                fazendo pose. Praesent vel viverra nisi. Mauris aliquet nunc non turpis scelerisque,
                eget.
              </p>
            </div>
          </slot>
        </div>
        <!--footer-->
        <div
          v-if="footer"
          class="border-neutral-20 flex w-full items-center justify-center border-t p-6"
          :class="{
            'min-h-[52px] px-4': size === 'sm',
            'min-h-[70px] px-6': size === 'md',
            'min-h-[76px] px-10': size === 'lg',
          }"
        >
          <slot name="footer">
            <div class="flex grow flex-row justify-end">
              <ImoButton text="Fechar" @click="closeModal" variant="secondary" />
            </div>
          </slot>
        </div>
      </div>
    </div>
    <div v-if="show" class="scrollbar fixed inset-0 z-40 bg-black/25 backdrop-blur-sm"></div>
  </div>
</template>

<script>
export default {
  name: 'ImoModal',
  components: {},
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    closeable: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: 'default',
    },
    footer: {
      type: Boolean,
      default: true,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    headerIcon: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'md',
      validators: value => ['sm', 'md', 'lg'].includes(value),
    },
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    closeModal() {
      this.$emit('close')
    },
    checkKeyEvent(event) {
      // SE ESC, fechar Modal.
      if (event.key === 'Escape') {
        this.closeModal()
        return
      }
      const focusableList = this.$refs.modalContainer.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      )
      // Se tiver menos de um elemento para FOCAR.
      if (focusableList.length < 2 && event.key === 'Tab') {
        event.preventDefault()
        return
      }
      // Adiciona ultimo elemento focável na lista
      const last = focusableList.length - 1
      if (event.key === 'Tab' && event.shiftKey === false && event.target === focusableList[last]) {
        event.preventDefault()
        focusableList[0].focus()
      } else if (
        event.key === 'Tab' &&
        event.shiftKey === true &&
        event.target === focusableList[0]
      ) {
        event.preventDefault()
        focusableList[last].focus()
      }
    },
  },
}
</script>

<style scoped>
/* Era `max-h-[90vh]`. No Safari do iOS/iPadOS, `vh` mede o viewport grande — como
   se as barras do navegador não existissem —, então o modal passa da área visível
   e o rodapé com os botões fica fora da tela (bug 86akhkqt2).

   `--app-height` vem do `window.innerHeight` (App.vue) e vale em qualquer
   navegador; `dvh` sobrescreve onde há suporte. Quem não conhece `dvh` descarta a
   segunda linha e fica com a primeira. */
.modal-max-height {
  max-height: calc(var(--app-height, 100vh) * 0.9);
  max-height: 90dvh;
}
</style>
